import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
const ALLY_AVATAR = 'https://cdn.magicpatterns.com/uploads/bhpiyD7vcY7JuLQFUBKxTh/logoanimado.webp';
const RESERVATIONS = [{
  name: 'Sarah P.',
  location: 'Manhattan'
}, {
  name: 'Robert M.',
  location: 'Lower Manhattan'
}, {
  name: 'Jessica L.',
  location: 'Upper East Side'
}, {
  name: 'Michael W.',
  location: 'Astoria'
}, {
  name: 'Daniela G.',
  location: 'Long Island City'
}, {
  name: 'Sarah P.',
  location: 'Queens'
}, {
  name: 'Robert M.',
  location: 'Long Island'
}, {
  name: 'Jessica L.',
  location: 'Williamsburg'
}];
const NOTIFICATION_INTERVAL = 30_000;
const DISPLAY_DURATION = 8_000;
export function ReservationNotification() {
  const [activeReservation, setActiveReservation] = useState(0);
  const [isVisible, setIsVisible] = useState(true);
  const reservation = RESERVATIONS[activeReservation];
  useEffect(() => {
    const intervalId = window.setInterval(() => {
      setActiveReservation(current => current === RESERVATIONS.length - 1 ? 0 : current + 1);
      setIsVisible(true);
    }, NOTIFICATION_INTERVAL);
    return () => window.clearInterval(intervalId);
  }, []);
  useEffect(() => {
    if (!isVisible) return undefined;
    const timeoutId = window.setTimeout(() => setIsVisible(false), DISPLAY_DURATION);
    return () => window.clearTimeout(timeoutId);
  }, [activeReservation, isVisible]);
  return <AnimatePresence data-id="element-225" data-mp="39dydz6f22uyh">
      {isVisible && <motion.aside key={`${reservation.name}-${reservation.location}`} role="status" aria-live="polite" aria-atomic="true" initial={{
      opacity: 0,
      x: -20,
      y: 12
    }} animate={{
      opacity: 1,
      x: 0,
      y: 0
    }} exit={{
      opacity: 0,
      x: -20,
      y: 12
    }} transition={{
      duration: 0.4,
      delay: 0.35
    }} className="fixed bottom-5 left-4 z-50 flex max-w-[calc(100vw-6.5rem)] items-center gap-3 rounded-2xl border border-slate-100 bg-white/95 p-3 shadow-xl shadow-slate/15 backdrop-blur-sm sm:bottom-6 sm:left-6 sm:max-w-sm" data-id="element-226" data-mp="39ezz63pscxtx">
          <img src={ALLY_AVATAR} alt="Cartoon illustration of Ally" className="h-11 w-11 shrink-0 rounded-full object-cover ring-2 ring-sky-softbg" data-id="element-227" data-mp="1uhnbes9j1s8g" />
          <p className="pr-4 text-sm font-medium leading-snug text-slate-soft" data-id="element-228" data-mp="1ll609p15xucp">
            <span className="mr-1 font-semibold text-slate" data-id="element-229" data-mp="16ox1spp3jl1c">Verified:</span>
            {reservation.name} from {reservation.location} just booked a
            Premium Service
          </p>
          <CheckCircle2Icon aria-hidden="true" className="absolute right-3 top-3 h-3.5 w-3.5 text-sky-brand" data-id="element-230" data-mp="xr4o1pz0wlg2" />
          <button type="button" onClick={() => setIsVisible(false)} aria-label="Dismiss booking notification" className="absolute -right-2 -top-2 inline-flex h-6 w-6 items-center justify-center rounded-full border border-slate-100 bg-white text-slate-muted shadow-sm transition-colors hover:bg-slate-50 hover:text-slate focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-magenta" data-id="element-231" data-mp="2s3ugs4dnnolv">
            <XIcon className="h-3.5 w-3.5" data-id="element-232" data-mp="3g0heqpdulmrr" />
          </button>
        </motion.aside>}
    </AnimatePresence>;
}